import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyvfUiModule } from '@myvf/ui';
import { SimSelectorComponent } from './sim-selector/sim-selector.component';

@NgModule({
  imports: [
    CommonModule,
    MyvfUiModule,
  ],
  declarations: [
    SimSelectorComponent,
  ],
  exports: [
    SimSelectorComponent,
  ],
})
export class SimSelectorModule {
}
